<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import agronomo from '@/src/services/agronomo'
import formAgronomo from '@/src/components/form-agronomo'
import importAgronomo from '@/src/components/import-agronomo'

/**
 * agronomo Component
 */
export default {
  components: {
    Layout,
    Loading,
    formAgronomo,
    importAgronomo,
  },
  data() {
    return {
      agronomoEdit: {},
      agronomos: [],
      agronomoForm: true,
      idUserDelete: '',
      modal: false,
      modalImport: false,
      isLoading: true,
      filter: '',
      artPrimaria: '',
      nReceitasArt: '',
      artImpressao: '',
      agronomoFields: [
        {
          key: 'nome',
          label: 'Nome'
        },
        {
          key: 'n_receitas_art',
          label: 'Receitas Por ART'
        },
        {
          key: 'ultima_receita',
          label: 'Última Receita Emitida'
        },
        {
          key: 'receita_art_disponivel',
          label: 'Receita Disponível',
        },
        { key: 'actions', label: '' },
      ],
      currentPage: 1,
      perPage: 20,
    }
  },
  computed: {
    rows() {
      return this.agronomos.length
    },
  },
  watch: {
    agronomoForm() {
      if (this.agronomoForm) {
        this.listando()
      }
    },
  },
  mounted() {
    this.listando()
  },
  methods: {
    listando() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      agronomo
        .listar(token)
        .then((resposta) => {
          this.agronomos = resposta.data.data
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    listandoByFilter() {
      if (this.filter != undefined) {
        const token = this.$store.state.auth.currentUser.token
        this.isLoading = true
        agronomo
          .listarByFilter(token, this.filter)
          .then((resposta) => {
            this.agronomos = resposta.data.data
            this.isLoading = false
          })
          .catch((error) => {
            this.agronomos = []
            this.isLoading = false
          })
      } else {
        this.listando()
      }
    },
    openModal(item) {
      this.idUserEdit = item
      this.$bvModal.show('modal-modificar-receita');
    },
    closeModal() {
      this.$bvModal.hide('modal-modificar-receita');
    },
    submitForm() {
      let data = {};

      if (this.artPrimaria.trim()) {
        data.art_primaria = this.artPrimaria;
      }
      if (this.nReceitasArt.trim()) {
        data.n_receitas_art = this.nReceitasArt;
      }
      if (this.artImpressao.trim()) {
        data.art_impressao = this.artImpressao;
      }

      const idUser = this.idUserEdit;
      const token = this.$store.state.auth.currentUser.token;

      this.isLoading = true;

      agronomo.editarART(idUser, token, data)
        .then((resposta) => {
          this.closeModal();
          this.listando();
          this.artPrimaria = "";
          this.nReceitasArt = "";
          this.artImpressao = "";
        })
        .catch((err) => {
          this.$bvToast.toast(
            'Ocorreu um erro ao editar, verifique os campos e tente novamente.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          );
        })
        .finally(() => {
          this.closeModal();
          this.isLoading = false;
        });
    },
    abrirForm() {
      if (this.agronomoForm === true) {
        this.agronomoForm = false
      } else {
        this.agronomoForm = true
        this.agronomoEdit = {}
      }
    },
    editRegister(agronomo) {
      this.agronomoEdit = agronomo
      console.log(agronomo)
      this.agronomoForm = false
    },
    modalDelete(item) {
      this.modal = true
      this.idUserDelete = item
    },
    handleDelete() {
      const token = this.$store.state.auth.currentUser.token
      agronomo
        .deleteAgronomo(token, this.idUserDelete)
        .then((reposta) => {
          this.listando()
        })
        .catch((err) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idUserDelete = null
      this.modal = false
    },
  },
}
</script>
<template>
  <Layout>
    <div class="bloco">
      <div>
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Responsável Técnico</div>
            <div class="subTitulo">Visualize, edite e cadastre novos Responsáveis Técnicos na plataforma.</div>
          </div>
          <div class="col-md-1">
            <div class="float-right">
              <button class="btn btn-primary" @click="abrirForm">
                <span v-if="agronomoForm">Novo</span>
                <span v-else>Ver todos</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div v-if="agronomoForm" class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Nome" label-for="filter">
              <b-form-input id="filter" v-model="filter" type="text"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2 mt-4 pt-1">
            <button class="btn btn-primary" @click="listandoByFilter">Pesquisar</button>
          </div>
          <div class="col-md-6 mt-4 pt-1">
            <div class="float-right">
              <button class="btn btn-primary" @click="modalImport = true">Importar</button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div v-if="agronomoForm">
          <b-table striped hover responsive="sm" borderless bordered outlined small :items="agronomos"
            :fields="agronomoFields" :current-page="currentPage" :per-page="perPage">
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2">
                <b-dropdown v-b-tooltip.hover size="md" variant="link" toggle-class="text-decoration-none" no-caret
                  title="Edite ou Delete o Responsável Técnico">
                  <template v-slot:button-content>
                    <i class="uil uil-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item @click="editRegister(row.item)">Editar</b-dropdown-item>
                  <b-dropdown-item @click="modalDelete(row.item.id_agronomo)">Excluir</b-dropdown-item>
                  <b-dropdown-item @click="openModal(row.item.id_agronomo)">Incluir ART</b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </b-table>
          <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"></b-pagination>
        </div>
        <div v-else>
          <formAgronomo :agronomo="agronomoEdit" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal v-model="modal" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>

    <b-modal v-model="modalImport" size="lg" title="Importação de Agrônomos" title-class="font-18" @hide="listando">
      <importAgronomo></importAgronomo>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="modalImport = false">Sair</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-modificar-receita" title="Incluir ART">
      <b-form>
        <b-form-group id="input-group-1" label="ART" label-for="input-1">
          <b-form-input id="input-1" v-model="artPrimaria" type="text" placeholder="Informe sua ART" autofocus
            required></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2" label="Número de Receitas Por ART" label-for="input-2">
          <b-form-input id="input-2" v-model="nReceitasArt" type="text" placeholder="Informe o nº de receitas por ART"
            required></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-3" label="Complemento do número" label-for="input-3">
          <template v-slot:label>
            Complemento do número
            <b-icon v-b-tooltip.hover role="button"
              title="O campo deve ser preenchido para complementar o número da receita ex: BR202203RA"
              icon="exclamation-circle-fill" variant="info"></b-icon>
          </template>
          <b-form-input id="input-3" v-model="artImpressao" v-no-autocomplete class="form-control" type="text"
            placeholder="Complemento do número" required></b-form-input>
        </b-form-group>
      </b-form>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="closeModal">Cancelar</b-button>
        <b-button variant="primary" @click="submitForm">Salvar</b-button>
      </template>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>